export const ssnRegex = {
  SE: /^(19|20)(\d{10})$/
};
